function getYoutubeVideoId(videoSrc: string) {
  return videoSrc?.split('/').pop()
}

export default getYoutubeVideoId
